import type { Currency } from "@loot-os/api-contract";
import type { ReactNode } from "react";

import { CurrencyContext } from "./currencyContext.js";

/** Sets the currency every Amount below it shows. Mount once with the storefront's config. */
export function CurrencyProvider({
  currency,
  children,
}: {
  currency: Currency;
  children: ReactNode;
}) {
  return <CurrencyContext.Provider value={currency}>{children}</CurrencyContext.Provider>;
}
